"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeReplacer = exports.post = void 0;
async function post(url, payload, authTokenFactory, applicationHeaderFactory, fetch) {
    return fetch(url, {
        method: 'post',
        headers: buildHeaders(authTokenFactory, applicationHeaderFactory),
        body: safeStringify(payload),
    });
}
exports.post = post;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value#examples
function safeStringify(data) {
    return JSON.stringify(data, makeReplacer());
}
function makeReplacer() {
    const seen = new WeakSet();
    return (_key, value) => {
        if (value instanceof Error) {
            // Most properties on Error are not enumerable so we need to do this to get them
            // https://stackoverflow.com/a/26199752/1654241
            const exposedError = {};
            Object.getOwnPropertyNames(value).forEach((key) => {
                const fieldValue = value[key];
                if (typeof fieldValue !== 'function') {
                    exposedError[key] = fieldValue;
                }
            });
            return exposedError;
        }
        else if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return '<CircularReference>';
            }
            seen.add(value);
        }
        return value;
    };
}
exports.makeReplacer = makeReplacer;
function buildHeaders(authTokenFactory, applicationHeaderFactory) {
    const authToken = authTokenFactory === null || authTokenFactory === void 0 ? void 0 : authTokenFactory();
    const applicationHeader = applicationHeaderFactory === null || applicationHeaderFactory === void 0 ? void 0 : applicationHeaderFactory();
    const headers = {};
    if (authToken !== undefined) {
        headers['Authorization'] = authToken;
    }
    if (applicationHeader !== undefined) {
        headers['Application'] = applicationHeader;
    }
    headers['Content-Type'] = 'application/json';
    return headers;
}
//# sourceMappingURL=post.js.map